import React from 'react'
import Navbar from './Navbar'
import Hero from './Hero'
import Footer from './Footer'

const Home = () => {
  return (
   <>
   <Navbar/>
   <Hero/>
   <Footer/>
   </>
  )
}

export default Home
